<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 4.3C6.79067 4.3 5 5.4635 5 6.9C5 8.3365 6.79067 9.5 9 9.5C11.2093 9.5 13 10.6635 13 12.1C13 13.5365 11.2093 14.7 9 14.7M9 4.3V14.7M9 4.3C10.48 4.3 11.7733 4.8226 12.4653 5.6M9 4.3V3M9 14.7V16M9 14.7C7.52 14.7 6.22667 14.1774 5.53467 13.4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
